const Fact = ({ label, value }) => {
    if (value == null || value === "") return null;
    return (
        <div style={{ minWidth: "140px" }}>
            <p style={{ fontSize: ".75rem", color: "var(--grey)", textTransform: "uppercase", letterSpacing: ".03em", marginBottom: ".2rem" }}>
                {label}
            </p>
            <p style={{ fontSize: ".95rem", fontWeight: 500 }}>{value}</p>
        </div>
    );
};

const NestedTable = ({ title, columns, rows, empty }) => {
    if (!rows?.length) {
        return <p className="sub-title">{empty}</p>;
    }
    return (
        <>
            <p style={{ fontSize: "1.05rem", fontWeight: 600, padding: "1rem 0 .6rem" }}>{title}</p>
            <div className="table-wrapper" style={{ height: "auto", maxHeight: "unset" }}>
                <table>
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th key={col.key}>{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={row.key || i}>
                                {columns.map((col) => (
                                    <td key={col.key}>
                                        {row[col.key] == null || row[col.key] === "" ? "—" : String(row[col.key])}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

const yn = (v) => {
    if (v === true) return "Y";
    if (v === false) return "N";
    return null;
};

const NetworkDefinition = ({ data }) => {
    const details = data?.details && !data.details.errorMessage ? data.details : null;
    const error = data?.details?.errorMessage;
    const name = details?.networkDefCompName || data?.networkDefCompName;
    const desc = details?.networkDefCompDesc || data?.networkDefCompDesc;
    const status = details?.networkDefCompStatusLabel
        || details?.networkDefCompStatus
        || data?.networkDefCompStatus;
    const tiers = details?.tiers || [];

    return (
        <>
            <p style={{ fontSize: "1.2rem", fontWeight: 600, padding: "0 0 .25rem" }}>
                {name || "Network Definition"}
            </p>
            {desc && desc !== name && <p className="sub-title">{desc}</p>}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem 1.6rem", padding: ".8rem 0 1rem" }}>
                <Fact label="Status" value={status} />
                <Fact label="Component key" value={details?.networkDefCompKey ?? data?.networkDefCompKey} />
                <Fact label="History fact" value={details?.networkDefCompHistFactKey ?? data?.networkDefCompHistFactKey} />
                <Fact label="Effective" value={details?.versionEffDate} />
                <Fact label="Expiration" value={details?.versionExpDate} />
                {data?.planName && <Fact label="Filtered plan" value={data.planName} />}
            </div>
            {error && <p className="danger">{error}</p>}
            {!error && !details && (
                <p className="sub-title">No Network Definition component details for this as-of date.</p>
            )}
            {tiers.map((tier) => (
                <div key={tier.inNtwkTierDefFactKey || tier.tierName} style={{ paddingBottom: "1rem" }}>
                    <p style={{ fontSize: "1.05rem", fontWeight: 600 }}>
                        {tier.tierName || "In-network tier"}
                    </p>
                    {tier.description && <p className="sub-title">{tier.description}</p>}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem 1.6rem", padding: ".4rem 0 .6rem" }}>
                        <Fact label="Self-referral" value={yn(tier.useForSelfReferral)} />
                        <Fact label="INN promotion" value={yn(tier.useForInNetworkPromotion)} />
                    </div>
                    <NestedTable
                        title="Benefit networks"
                        columns={[
                            { key: "benefitNetworkName", label: "name" },
                            { key: "benefitNetworkDesc", label: "description" },
                            { key: "benefitNetworkStatusLabel", label: "status" },
                            { key: "benefitNetworkKey", label: "key" },
                        ]}
                        rows={(tier.benefitNetworks || []).map((n) => ({
                            ...n,
                            key: n.benefitNetworkKey,
                            benefitNetworkStatusLabel: n.benefitNetworkStatusLabel || n.benefitNetworkStatus,
                        }))}
                        empty="No benefit networks on this tier."
                    />
                </div>
            ))}
            {details && !tiers.length && (
                <p className="sub-title">This Network Definition has no in-network tiers as of this date.</p>
            )}
        </>
    );
};

export default NetworkDefinition;
